var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWheelchairMotor = function SvgWheelchairMotor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.208 21.28a2 2 0 1 0 4 0 2 2 0 1 0-4 0m2.5-8a11.1 11.1 0 0 1 4.5-1l3.577.046m4.99-6.777L17.52 16.395m1.062-9.283.759-6.163S15.688-.317 14.944 3.1s3.638 4.012 3.638 4.012M5.708 9.28v6.5m11.427.084 1.144-.084c1.894 0 3.429 1.221 3.429 2.727v.838m-17.02.003 1.02-3.568M2.415 7.8l2.056-1.373a1 1 0 0 0 .394-1.148l-.882-2.3a1 1 0 0 0-1.191-.654l-2 .552 1.416 4.4a2.67 2.67 0 0 0 2.5 2h5.837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.208 21.28a2 2 0 1 0 4 0 2 2 0 1 0-4 0m-10-2.5a4.5 4.5 0 1 0 9 0 4.5 4.5 0 1 0-9 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.208 18.78a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m-6.5-3h4.647m3.845-1.472s-1.164-3.592.01-6.528a4.85 4.85 0 0 1 1.343-2.123"
  })));
};
export default SvgWheelchairMotor;